export default __webpack_public_path__ + "media/images/onglet-gauche-admin-315d134174d1fdbc6324391c574da340.png";